// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { samlAttributeMappingGuard, samlAcsUrlGuard, samlEncryptionGuard, samlAuthnRequestConfigGuard, nameIdFormatGuard, samlStaticAttributesGuard } from './../foundations/index.js';
const createGuard = z.object({
    applicationId: z.string().min(1).max(21),
    tenantId: z.string().max(21).optional(),
    attributeMapping: samlAttributeMappingGuard.optional(),
    entityId: z.string().max(128).nullable().optional(),
    acsUrl: samlAcsUrlGuard.nullable().optional(),
    encryption: samlEncryptionGuard.nullable().optional(),
    authnRequestConfig: samlAuthnRequestConfigGuard.nullable().optional(),
    nameIdFormat: nameIdFormatGuard,
    staticAttributes: samlStaticAttributesGuard.optional(),
});
const guard = z.object({
    applicationId: z.string().min(1).max(21),
    tenantId: z.string().max(21),
    attributeMapping: samlAttributeMappingGuard,
    entityId: z.string().max(128).nullable(),
    acsUrl: samlAcsUrlGuard.nullable(),
    encryption: samlEncryptionGuard.nullable(),
    authnRequestConfig: samlAuthnRequestConfigGuard.nullable(),
    nameIdFormat: nameIdFormatGuard,
    staticAttributes: samlStaticAttributesGuard,
});
export const SamlApplicationConfigs = Object.freeze({
    table: 'saml_application_configs',
    tableSingular: 'saml_application_config',
    fields: {
        applicationId: 'application_id',
        tenantId: 'tenant_id',
        attributeMapping: 'attribute_mapping',
        entityId: 'entity_id',
        acsUrl: 'acs_url',
        encryption: 'encryption',
        authnRequestConfig: 'authn_request_config',
        nameIdFormat: 'name_id_format',
        staticAttributes: 'static_attributes',
    },
    fieldKeys: [
        'applicationId',
        'tenantId',
        'attributeMapping',
        'entityId',
        'acsUrl',
        'encryption',
        'authnRequestConfig',
        'nameIdFormat',
        'staticAttributes',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
